const medicineTariffCodes = [
  "400",
  "401",
  "402",
  "403",
  "404",
  "408",
  "410"
];

export const isMedicineTariffCode = (code: string): boolean => {
  return medicineTariffCodes.includes("" + code);
}
